import Button from 'components/UI/V3/Button/Button';
import { ChangeEvent, forwardRef } from 'react';
import styles from './LeadNoteComposer.module.scss';

interface LeadNoteComposerProps {
    value: string;
    isEditing: boolean;
    isSaving: boolean;
    onChange: (value: string) => void;
    onSubmit: () => void;
    onCancel: () => void;
}

const MAX_LENGTH = 1000;

const LeadNoteComposer = forwardRef<HTMLTextAreaElement, LeadNoteComposerProps>(
    ({ value, isEditing, isSaving, onChange, onSubmit, onCancel }, ref) => (
        <div className={styles.root}>
            <textarea
                ref={ref}
                className={styles.input}
                value={value}
                disabled={isSaving}
                maxLength={MAX_LENGTH}
                placeholder="Write a note here..."
                onChange={(event: ChangeEvent<HTMLTextAreaElement>) => onChange(event.currentTarget.value)}
            />

            <div className={styles.actions}>
                {isEditing && (
                    <Button
                        label="Cancel"
                        variant="black"
                        size="small"
                        disabled={isSaving}
                        onClick={onCancel}
                    />
                )}
                <Button
                    label={isEditing ? 'Save' : 'Post'}
                    variant="green"
                    size="small"
                    isLoading={isSaving}
                    disabled={isSaving || value.trim().length === 0}
                    onClick={onSubmit}
                />
            </div>
        </div>
    )
);

LeadNoteComposer.displayName = 'LeadNoteComposer';

export default LeadNoteComposer;
